
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/api/no-ssr",
      function () {
        return require("private-next-pages/material-ui/api/no-ssr.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/api/no-ssr"])
      });
    }
  